<script setup lang="ts">
import SVG from "@/stories/displays/SVG/SVG.vue";
import { toRefs } from "vue";

type CheckboxSize = "md" | "lg";

interface Props {
  checked?: boolean;
  disabled?: boolean;
  tabindex?: number;
  size?: CheckboxSize;
}

const props = withDefaults(defineProps<Props>(), {
  size: "md",
});

const { size } = toRefs(props);

const SIZE_MAP: Record<CheckboxSize, string> = {
  md: "w-6 h-6 min-w-6 min-h-6",
  lg: "w-8 h-8 min-w-8 min-h-8",
};

const ICON_SIZE_MAP: Record<CheckboxSize, string> = {
  md: "1.25rem",
  lg: "1.625rem",
};

const currentSize = SIZE_MAP[size.value];
const iconSize = ICON_SIZE_MAP[size.value];
</script>

<template>
  <button
    type="button"
    class="border flex items-center justify-center cursor-pointer focusVisible rounded"
    :tabindex="tabindex"
    :disabled="disabled"
    :class="{
      [currentSize]: true,
      'bg-darkOcean600 border-none': checked && !disabled,
      'bg-darkOcean600 opacity-60 text-neutral0 border-none':
        checked && disabled,
      'bg-white border-neutral400': !checked && disabled,
      'bg-white border-neutral700': !checked && !disabled,
    }"
  >
    <SVG
      v-if="checked"
      icon="fas-check"
      class="text-neutral50"
      :width="iconSize"
      :height="iconSize"
    ></SVG>
  </button>
</template>
